import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authMe, authLogout, setToken, getToken } from "./api";

const AuthCtx = createContext({ user: null, refresh: () => {}, login: () => {}, logout: () => {} });

/** user: null = checking · false = anonymous · object = authenticated */
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!getToken()) { setUser(false); return false; }
    try {
      const me = await authMe();
      setUser(me);
      return me;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = (token, account) => { setToken(token); setUser({ ...account, wallet: account?.billing || null }); refresh(); };
  const logout = async () => { await authLogout(); setToken(null); setUser(false); };

  return <AuthCtx.Provider value={{ user, refresh, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">Caricamento…</div>;
  if (!user) return <Navigate to={`/accedi?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (!user.email_verified) return <Navigate to="/verifica-email" replace />;
  return children;
}
